export default class CreateAsistencia {
  #repository
  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, payload) {
    try {
      const result = await this.#repository.create({ idPersonal, ...payload })
      return result
    } catch (error) {
      console.error('Error al crear la asistencia:', error)
      throw error
    }
  }
}
